import React from 'react';

import { Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useBreakpoint } from 'common/hooks';
import { panelTypeToLabel } from 'common/utils/helpers';

import ProductActionsFormatter from './ProductActionsFormatter';

const ProductColumns = ({ handleClickAdd, panelsIdsData }) => {
    const { t } = useTranslation();
    const breakpoint = useBreakpoint();

    let columns = [
        {
            align: 'left',
            field: 'name',
            display: 'flex',
            flex: 1,
            headerName: t('Name'),
            renderCell: (params) => {
                const { row } = params;
                return <Typography variant="caption">{row.name}</Typography>;
            },
        },
        {
            align: 'left',
            field: 'code',
            display: 'flex',
            flex: 1,
            headerName: t('Code'),
            renderCell: (params) => {
                const { row } = params;
                return <Typography variant="caption">{row.code}</Typography>;
            },
        },
        {
            align: 'left',
            field: 'brand',
            display: 'flex',
            flex: 1,
            headerName: t('Brand'),
            valueGetter: (_, row) => row?.brand?.name,
        },
        {
            align: 'left',
            display: 'flex',
            field: 'product_type',
            flex: 1,
            headerName: t('Type'),
            renderCell: (params) => {
                const { row } = params;
                return panelTypeToLabel(row.product_type);
            },
        },
    ];

    if (['xs', 'sm'].includes(breakpoint)) {
        columns = [
            {
                align: 'left',
                display: 'flex',
                field: 'name',
                flex: 1,
                headerName: t('Name'),
                renderCell: (params) => {
                    const { row } = params;
                    return (
                        <Typography variant="caption">{row.name}</Typography>
                    );
                },
            },
        ];
    }

    columns = [
        ...columns,
        {
            align: 'left',
            display: 'flex',
            field: '',
            flex: 1,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <ProductActionsFormatter
                        handleClickAdd={handleClickAdd}
                        panelsIdsData={panelsIdsData}
                        row={row}
                    />
                );
            },
            sortable: false,
        },
    ];

    return columns;
};

ProductColumns.propTypes = {
    handleClickAdd: PropTypes.func,
};

export default ProductColumns;
